e4.favorites = {
    bindEventsDone: false,
    init: function () {
        if ( jQuery( '.js-e-product-favorites,.js-e-favorites-list-modal,.js-favorites-product-list,.js-e-productlist' ).length > 0 ) {
            e4.favorites.bindEvents();
        }
    },
    bindEvents: function () {
        jQuery( document ).on( 'show.bs.modal', '#js-e-favorites-rename-list-modal', function ( event ) {
            e4.favorites.setFormValues( event.target, event.relatedTarget );
        } ).on( 'shown.bs.modal', '.js-e-favorites-list-modal', function ( event ) {
            e4.favorites.setFormInputFocus( event.target );
        } ).on( 'hidden.bs.modal', '#js-e-favorites-rename-list-modal', function ( event ) {
            e4.favorites.clearFormValues( event.target );
        } );
        // TODO: Refactor to use require namespace to fix this
        if ( e4.favorites.bindEventsDone === false ) {
            e4.favorites.bindEventsDone = true;
            jQuery( document ).on( 'change', '.js-e-product-favorites-list-input', function ( event ) {
                e4.favorites.product.toggleList( event.target );
            } ).on( 'click', '.js-e-product-favorites-create-list-submit-btn', function ( event ) {
                e4.favorites.product.createList( event.target );
            } ).on( 'keydown keypress', '.js-e-product-favorites-create-list-name-input', function ( event ) {
                if ( event.keyCode === 13 ) {
                    event.preventDefault();
                    e4.favorites.product.createList( event.target );
                }
            } ).on( 'shown.bs.collapse', '.js-e-product-favorites-create-list', function ( event ) {
                e4.favorites.product.setCreateListNameInputFocus( event.target );
            } ).on( 'show.bs.dropdown', '.js-e-product-favorites', function ( event ) {
                e4.favorites.product.buildLists( event.target ).done( function () {
                    e4.favorites.product.setIcon( event.target );
                } );
            } ).on( 'hidden.bs.dropdown', '.js-e-product-favorites', function ( event ) {
                e4.favorites.product.setIcon( event.target );
                e4.favorites.product.clearLists( event.target );
            } );
        }
        jQuery( '.js-favorites-filter-lists' ).on( 'change', e4.favorites.filterList );
        jQuery( '.js-favorites-add-all-to-cart' ).on( 'click', e4.favorites.addAllToCart );
        jQuery( '.js-favorites-share-button' ).on( 'click', function(event){
            event.preventDefault();
            jQuery.ajax({
                url: event.target.href
            }).done(function(){
                location.reload();
            })
        } );
    },
    filterList: function ( event ) {
        event.target.form.submit();
    },
    setFormInputFocus: function ( domModal ) {
        jQuery( domModal ).find( 'input[type="text"]' ).first().trigger( 'focus' );
    },
    setFormValues: function ( domModal, domTriggerNode ) {
        var jModal = jQuery( domModal ),
            jTriggerNode = jQuery( domTriggerNode );
        jModal.find( '.js-e-favorites-rename-list-form' ).attr( 'action', function () {
            return jTriggerNode.attr( 'href' );
        } ).find( '.js-e-favorites-rename-list-form-name-input' ).val( jTriggerNode.data( 'list-name' ) );
    },
    addAllToCart: function () {
        var jProductItems = jQuery( '.js-favorites-product-list' ).find( '.js-e-productlist-item' ),
            objFormData = {
                CartCmd: 'AddMulti',
                Redirect: false
            };

        jProductItems.each( function ( index, domElm ) {
            objFormData[ 'ProductLoopCounter' + index ] = index;
            objFormData[ 'ProductID' + index ] = jQuery( domElm ).data( 'productId' );
            objFormData[ 'VariantID' + index ] = jQuery( domElm ).data( 'variantId' );
            objFormData[ 'Quantity' + index ] = jQuery( domElm ).data( 'purchaseQuantityMinimum' );
        } );
        e4.cart.addProduct( objFormData );
    },
    clearFormValues: function ( domModal ) {
        jQuery( domModal ).find( '.js-e-favorites-rename-list-form' ).attr( 'action', '' ).find( '.js-e-favorites-rename-list-form-name-input' ).val( '' );
    },
    product: {
        toggleList: function ( domInput ) {
            var jInput = jQuery( domInput );
            if ( jInput.prop( 'checked' ) === true ) {
                e4.favorites.product.addToList( jInput ).done( function () {
                    e4.favorites.product.setIcon( jInput.get(0) );
                } );
            }
            else {
                e4.favorites.product.removeFromList( jInput ).done( function () {
                    e4.favorites.product.setIcon( jInput.get(0) );
                } );
            }
        },
        addToList: function ( jInput ) {
            jInput.prop( 'disabled', true );
            return e4.util.ajax( {
                url: jInput.data( 'url-add' )
            }, function () {
                jInput.prop( 'disabled', false );
            } );
        },
        removeFromList: function ( jInput ) {
            jInput.prop( 'disabled', true );
            return e4.util.ajax( {
                url: jInput.data( 'url-remove' )
            }, function () {
                jInput.prop( 'disabled', false );
            } );
        },
        addToNewList: function ( domNode, intLastAddedId ) {
            var jNewListInput = jQuery( domNode ).closest( '.js-e-product-favorites' ).find( '.js-e-product-favorites-list-input[data-list-id="' + intLastAddedId + '"]' );
            jNewListInput.closest( '.dropdown-item' ).addClass( 'bg-light' );
            e4.favorites.product.toggleList( jNewListInput.prop( 'checked', true ).get( 0 ) );
        },
        setCreateListNameInputFocus: function ( domNode ) {
            jQuery( domNode ).find( '.js-e-product-favorites-create-list-name-input' ).trigger( 'focus' );
        },
        createList: function ( domNode ) {
            var jFavoritesCreateList = jQuery( domNode ).closest( '.js-e-product-favorites-create-list' ),
                jFavorites = jFavoritesCreateList.closest( '.js-e-product-favorites' ),
                jNameInput = jFavoritesCreateList.find( '.js-e-product-favorites-create-list-name-input' );
            if ( jNameInput.val() !== '' ) {
                e4.util.ajax( {
                    url: jFavoritesCreateList.data( 'create-list-url' ),
                    method: 'POST',
                    beforeSend: function () {
                        jFavorites.find( '.js-e-loading-overlay' ).addClass( 'is-loading' );
                    },
                    data: {
                        Name: jNameInput.val(),
                    }
                }, function () {
                    jFavorites.one( 'loaded.e4.jsonpublisher', function ( event, jsonData ) {
                        e4.favorites.product.addToNewList( event.target, jsonData.lastAddedListId );
                    } );
                    e4.favorites.product.buildLists( domNode ).done( function () {
                        e4.favorites.product.setIcon( domNode );
                    } );
                    jNameInput.val( '' );
                    jFavoritesCreateList.find( '.js-e-product-favorites-create-list' ).collapse( 'hide' );
                } );
            }
            else {
                jNameInput.trigger( 'focus' );
            }
        },
        setIcon: function ( domNode ) {
            var jFavorites = jQuery( domNode ).closest( '.js-e-product-favorites' ),
                intSelectedItems = jFavorites.find( '.js-e-product-favorites-lists' ).find( '.js-e-product-favorites-list-input' ).filter( ':checked' ).length,
                jIconWithoutSelectedItems = jFavorites.find( '.js-e-favorites-icon-without-selected-items' ),
                jIconWithSelectedItems = jFavorites.find( '.js-e-favorites-icon-with-selected-items' );
            if ( intSelectedItems > 0 ) {
                jIconWithoutSelectedItems.addClass( 'd-none' );
                jIconWithSelectedItems.removeClass( 'd-none' );
            }
            else {
                jIconWithoutSelectedItems.removeClass( 'd-none' );
                jIconWithSelectedItems.addClass( 'd-none' );
            }
            console.log( 'intSelectedItems', intSelectedItems );
        },
        buildLists: function ( domNode ) {
            var jFavorites = jQuery( domNode ).closest( '.js-e-product-favorites' ),
                domFavorites = jFavorites.get( 0 );
            jFavorites.find( '.js-e-loading-overlay' ).addClass( 'is-loading' );
            return e4.jsonpublisher.reload( domFavorites, {
                jsonSrc: e4.settings.ecom.favorites.url
            } ).done( function () {
                jFavorites.find( '.js-e-loading-overlay' ).removeClass( 'is-loading' );
            } );
        },
        clearLists: function ( domNode ) {
            jQuery( domNode ).find( '.js-e-product-favorites-lists' ).html( '' );
        }
    }
};
